import { AuthProvider, useAuth } from './auth/AuthContext';
import { AppShell } from './AppShell';
import { Blocker } from './components/Blocker';

export type ScreenId = 'dashboard' | 'map' | 'schedule' | 'engineers' | 'clients' | 'reports' | 'settings';

export function App() {
  return (
    <AuthProvider>
      <Root />
    </AuthProvider>
  );
}

function Root() {
  const { state, retry, embedded } = useAuth();

  if (state.status === 'idle' || state.status === 'loading') {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b' }}>
        <div style={{ textAlign: 'center' }}>
          <div className="fd-pulse" style={{ fontSize: 12, letterSpacing: '2px', fontWeight: 700, color: '#60a5fa' }}>
            FIELDDESK
          </div>
          <div style={{ fontSize: 13, marginTop: 8 }}>
            {embedded ? 'Авторизация через Битрикс24…' : 'Загрузка…'}
          </div>
        </div>
      </div>
    );
  }

  if (state.status === 'unauthenticated') {
    const isNoBx24 = state.reason === 'no-bx24';
    return (
      <Blocker
        title={isNoBx24 ? 'Доступ только из Битрикс24' : 'Не удалось авторизоваться'}
        message={state.message}
        action={!isNoBx24 ? { label: 'Повторить', onClick: retry } : undefined}
      />
    );
  }

  return <AppShell user={state.user} embedded={embedded} dealId={state.placement?.dealId ?? null} />;
}
